import React, { useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { KeenIcon, DefaultTooltip, FormikUnsavedChangesGuard } from '@/components';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { toast } from 'sonner';
import { useAbility } from '@/providers/';
import { CategoryModal } from '@/pages/billing';
import { Stepper, Step, StepLabel } from '@mui/material';
import { Setup, Items, Expense, FlatFees, CreateInvoice, StepContainer } from '@/components';
import { formatDateToYMD } from '@/utils';
import { ItemsModal } from '@/pages/billing';
import itemService from '@/services/billing/itemService';
import categoryService from '@/services/billing/expenses/categoryService';
import { useSearchParams } from 'react-router-dom';

const AddInvoice = () => {
  const [dataLoading, setDataLoading] = useState(false)
  const [createInvoice, setCreateInvoice] = useState(false);
  const [open, setOpen] = useState(false);
  const [openItem, setOpenItem] = useState(false)
  const [mode, setMode] = useState('create');
  const [itemId, setItemId] = useState(null)
  const [selectedData, setSelectedData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const { action, id } = useParams();
  const invoiceId = id;
  const location = useLocation();
  const Navigate = useNavigate()
  const { ability } = useAbility();
  const formikRef = useRef();
  const steps = ['Setup', 'Items', 'Expense', 'Flat Fees', 'Create Invoice'];
  const [activeStep, setActiveStep] = useState(0);
  const isLastStep = activeStep === steps.length - 1;
  const currentDate = new Date().toISOString().split('T')[0];
  const [templateData, setTemplateData] = useState(null);
  const isEdit = action === 'edit';
  const isClone = action === 'create' && !!id;
  const isCreate = action === 'create' && !id;
  const isValidAction = isEdit || isClone || isCreate;
  const [taxesData, setTaxesData] = useState([])
  const [itemCreated, setItemCreated] = useState(false);
  const [categoryCreated, setCategoryCreated] = useState(false);
  const [searchParams] = useSearchParams();
  // const contactId = searchParams.get('contactId');
  // const matterId = searchParams.get('matterId');
  const { from, contactId, matterId } = location.state || {};

  useEffect(() => {
    if (!isValidAction) return Navigate('/error/404');
  }, [!isValidAction])


  console.log(action, id)

  const validationSchemas = [
    Yup.object().shape({
      contact_id: Yup.string().required('Contact is required'),
      matter_id: Yup.string(),
      date: Yup.date().required('Date is required').typeError('Invalid date format'),
      due_date: Yup.date()
        // .required('Due date is required')
        .typeError('Invalid due date')
        .when('date', (date, schema) =>
          date ? schema.min(date, 'Due date cannot be before issue date') : schema
        ),
      discount_percent: Yup.number()
        .typeError('Discount must be a number')
        .min(0, 'Discount cannot be negative')
        .max(100, 'Discount cannot exceed 100')
        .nullable(),
    }),

    // Time Entries
    Yup.object().shape({
      time_entries: Yup.array().of(
        Yup.object().shape({
          item_id: Yup.string().test(
            'item-required-if-any-field-filled',
            'Item is required',
            function (value) {
              const { rate, quantity, date } = this.parent;
              const anyFieldFilled = [rate, quantity, date].some((v) => v !== null && v !== undefined && v !== '');
              return anyFieldFilled ? !!value : true;
            }
          ),

          rate: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema.required('Rate is required').typeError('Rate must be a number').min(0, 'Rate cannot be negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          quantity: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema.required('Hours is required').min(0.000001, 'Hours cannot be 0 or negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          date_to: Yup.date()
            .transform((value, original) => (original === '' || original === null ? null : value))
            .nullable()
            .min(Yup.ref('date'), 'The end date must be on or after the start date'),
          date: Yup.date()
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) => schema.required('Date is required'),
              otherwise: (schema) => schema.notRequired(),
            }),

          description: Yup.string().max(255, 'Max 255 characters'),
        })
      ),
    }),



    // Expenses
    Yup.object().shape({
      expenses: Yup.array().of(
        Yup.object().shape({
          category_id: Yup.string().test(
            'category-required-if-other-fields',
            'Expense category is required',
            function (value) {
              const { rate, quantity } = this.parent;
              const hasOtherValues = rate != null || quantity != null;
              return hasOtherValues ? !!value : true;
            }
          ),

          rate: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('category_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema
                  .required('Rate is required')
                  .min(0, 'Rate cannot be negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          quantity: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('category_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema
                  .required('Quantity is required')
                  .min(1, 'Quantity cannot be 0 or negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          date_to: Yup.date()
            .transform((value, original) => (original === '' || original === null ? null : value))
            .nullable()
            .min(Yup.ref('date'), 'The end date must be on or after the start date'),
          date: Yup.date()
            .nullable()
            .when('category_id', {
              is: (id) => !!id,
              then: (schema) => schema.required('Date is required'),
              otherwise: (schema) => schema.notRequired(),
            }),

          description: Yup.string().max(255, 'Max 255 characters'),
        })
      ),
    }),

    // Flat Fees
    Yup.object().shape({
      flat_fees: Yup.array().of(
        Yup.object().shape({
          item_id: Yup.string().test(
            'item-required-if-any-field-filled',
            'Flat fee item is required',
            function (value) {
              const { rate, quantity, date } = this.parent;
              const anyFieldFilled = [rate, quantity, date].some((v) => v !== null && v !== undefined && v !== '');
              return anyFieldFilled ? !!value : true;
            }
          ),

          rate: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema.required('Rate is required').typeError('Rate must be a number').min(0, 'Rate cannot be negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          quantity: Yup.number()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === undefined ? null : Number(originalValue)
            )
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) =>
                schema.required('Quantity is required').min(1, 'Quantity cannot be 0 or negative'),
              otherwise: (schema) => schema.notRequired(),
            }),

          date_to: Yup.date()
            .transform((value, original) => (original === '' || original === null ? null : value))
            .nullable()
            .min(Yup.ref('date'), 'The end date must be on or after the start date'),
          date: Yup.date()
            .nullable()
            .when('item_id', {
              is: (val) => !!val,
              then: (schema) => schema.required('Date is required'),
              otherwise: (schema) => schema.notRequired(),
            }),

          description: Yup.string().max(255, 'Max 255 characters'),
        })
      ),
    }),


  ];


  const getBusinessName = () => {
    if (isCreate || isClone) {
      console.log('---->', templateData)
      return templateData?.contact?.business_name
    } else if (isEdit) {
      return templateData?.invoice_business_name
    } else {
      return '';
    }
  }
  // useEffect(() => {
  //   getBusinessName()
  // }, [templateData?.contact])


  const initialValues = {
    contact_id: templateData?.contact?.id || '',
    contact: templateData?.contact
      ? {
        label: `${templateData.contact.first_name} ${templateData.contact.last_name}`,
        value: templateData.contact.id,
        id: templateData.contact.id,
        email: templateData.contact.email,
        business_name: templateData.contact.business_name
      }
      : null,
    invoice_business_name: getBusinessName(),
    matter_id: templateData?.matter?.id || '',
    matter: templateData?.matter
      ? {
        label: templateData.matter.name,
        value: templateData.matter.id,
        id: templateData.matter.id
      }
      : null,
    invoice_template_id: invoiceId ? templateData?.invoice_template?.id : '',
    invoice_template: invoiceId ? templateData?.invoice_template
      ? {
        label: templateData.invoice_template.name,
        value: templateData.invoice_template.id,
        id: templateData.invoice_template.id
      } : null : null,
    date: formatDateToYMD(templateData?.date || currentDate),
    due_date: formatDateToYMD(templateData?.due_date || ''),
    is_approval_required: templateData?.is_approval_required || false,
    discount_percent: templateData?.discount_percent || 0,
    // number: templateData?.number || '',
    total: templateData?.total || '',
    time_entries: Array.isArray(templateData?.time_entries)
      ? templateData.time_entries.map((item) => ({
        item_id: item.item.id || '',
        item: {
          label: item.item.name,
          value: item.item.id,
          id: item.item.id,
          // rate: item.item.rate
        },
        description: item?.description || '',
        billed_by: item?.billed_by?.id || '',
        billed_by_user: {
          label: item?.billed_by?.first_name + ' ' + item?.billed_by?.last_name,
          value: item?.billed_by?.id,
          id: item?.billed_by?.id,
          email: item?.billed_by?.email
        },
        quantity: item?.quantity || '',
        rate: item?.rate.toString() || '', // stringify rate if its 0 input will ignore
        date: formatDateToYMD(item?.date || ''),
        date_to: formatDateToYMD(item?.date_to || ''),
        tax: item?.taxes?.map(t => t.id) || [],
        taxes: item?.taxes
          ? item.taxes.map(t => ({
            label: t.name,
            value: t.id,
            id: t.id,
            rate: t.rate
          })) : [],
      }))
      : [
        {
          item_id: '',
          item: null,
          description: '',
          billed_by: '',
          billed_by_user: null,
          quantity: '',
          rate: '',
          date: '',
          date_to: '',
          tax: []
        },
      ],
    expenses: Array.isArray(templateData?.expenses)
      ? templateData.expenses.map((item) => ({
        category_id: item.category.id || '',
        expense: {
          label: item.category.category_name,
          value: item.category.id,
          id: item.category.id,
        },
        description: item?.description || '',
        billed_by: item?.billed_by?.id || '',
        billed_by_user: {
          label: item?.billed_by?.first_name + ' ' + item?.billed_by?.last_name,
          value: item?.billed_by?.id,
          id: item?.billed_by?.id,
          email: item?.billed_by?.email
        },
        quantity: item?.quantity || '',
        rate: item?.rate || '',
        date: formatDateToYMD(item?.date || ''),
        date_to: formatDateToYMD(item?.date_to || ''),
        tax: item?.taxes?.map(t => t.id) || [],
        taxes: item?.taxes
          ? item.taxes.map(t => ({
            label: t.name,
            value: t.id,
            id: t.id,
            rate: t.rate
          })) : [],
      })) : [
        {
          category_id: '',
          expense: null,
          description: '',
          billed_by: '',
          billed_by_user: null,
          quantity: '',
          rate: '',
          date: '',
          date_to: '',
          tax: []

        }
      ],
    flat_fees: Array.isArray(templateData?.flat_fees)
      ? templateData.flat_fees.map((item) => ({
        item_id: item.item.id || '',
        flat_fee: {
          label: item.item.name,
          value: item.item.id,
          id: item.item.id,
        },
        description: item?.description || '',
        billed_by: item?.billed_by?.id || '',
        billed_by_user: {
          label: item?.billed_by?.first_name + ' ' + item?.billed_by?.last_name,
          value: item?.billed_by?.id,
          id: item?.billed_by?.id,
          email: item?.billed_by?.email
        },
        quantity: item?.quantity || '',
        rate: item?.rate.toString() || '', // stringify rate if its 0 input will ignore
        date: formatDateToYMD(item?.date || ''),
        date_to: formatDateToYMD(item?.date_to || ''),
        tax: item?.taxes?.map(t => t.id) || [],
        taxes: item?.taxes
          ? item.taxes.map(t => ({
            label: t.name,
            value: t.id,
            id: t.id,
            rate: t.rate
          })) : [],
      })) : [
        {
          item_id: '',
          flat_fee: null,
          description: '',
          billed_by: '',
          billed_by_user: null,
          quantity: '',
          rate: '',
          date: '',
          date_to: '',
          tax: []
        }
      ],
    terms_and_conditions: templateData?.terms_and_conditions || '',
    terms_and_conditions_note: templateData?.terms_and_conditions_note || '',
    invoice_status: 'billed',
    send_payment_reminder: false,
    template_Settings: null,
    subtotal: templateData?.subtotal || '',
    discount: templateData?.discount || '',
    subtotal_after_discount: templateData?.subtotal_after_discount || '',
    taxes: templateData?.taxes || [],
  }

  useEffect(() => {
    console.log('--->', initialValues)

  }, [initialValues])

  const handleModalClose = () => {
    setItemId(null)
    setSelectedData(null)
    setMode('create')
    setOpen(false)
    setOpenItem(false)
  }

  const handleSubmit = async (formData, resetForm, setErrors, isForPreview = false) => {
    setCreateInvoice(true);
    const action = isEdit ? invoiceService.updateInvoice : invoiceService.createInvoice;
    const args = isEdit ? [formData, invoiceId] : [formData];
    // console.log('formData', formData)
    // return
    if (
      (!formData.time_entries || formData.time_entries.length === 0) &&
      (!formData.flat_fees || formData.flat_fees.length === 0) &&
      (!formData.expenses || formData.expenses.length === 0)
    ) {
      toast.warning('Nothing to Submit', {
        description: 'You must add at least one entry in Time Entries, Flat Fees, or Expenses.',

      });
      setCreateInvoice(false);
      return;
    } else {
      try {
        const { data, status } = await action(...args);
        if (status) {
          resetForm()
          toast.success(`Invoice ${isEdit ? 'Updated' : 'Created'}.`, {
            description: `Invoice ${isEdit ? 'Updated' : 'Created'} Successfully.`,
            action: {
              label: 'Ok',
            },
          });
          Navigate(from || '/billing/invoices/invoice')
        }
      } catch (error) {
        console.error('Error', error)
        if (error.message == '422 Unprocessable Entity. Validation failed.') {
          const responseErrors = error.errors || {};
          const formattedErrors = {};

          Object.entries(responseErrors).forEach(([key, value]) => {
            formattedErrors[key] = value[0];
          });
          setErrors(formattedErrors)
          toast.warning('Validation Error.', {
            description: 'Please check your input. Some fields may be invalid.',
            action: {
              label: 'Ok',
            },
          });
          setCreateInvoice(false);
          return
        }
        toast.error(`Failed to ${isEdit ? 'Updated' : 'Created'} Flat Fee.`, {
          description: `An error occurred while ${isEdit ? 'Updated' : 'Created'} flat fee. Please try again later.`,

        });
      } finally {
        setCreateInvoice(false);
      }
    }
  }

  const getSingleInvoice = async (id) => {
    console.log('getSingleInvoice', id);

    setDataLoading(true)
    try {
      const { data, status } = await invoiceService.getSingleInvoice(id);
      // return console.log(data)
      if (status) {
        setTemplateData(data)
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Failed to fetch Invoice Details.', {
        description: 'An error occurred while fetching invoice details. Please try again later.',

      });
    } finally {
      setDataLoading(false)
    }
  }

  useEffect(() => {
    if (invoiceId) { getSingleInvoice(invoiceId); }
  }, [])

  const transformTaxFields = (array = [], idKey = 'item_id') => {
    return array.map((item) => {
      const { [idKey]: customId, tax = [], taxes = [], ...rest } = item;

      const enrichedTax = tax.map((t) => {
        // Handle full object OR just ID
        const taxId = typeof t === 'string' ? t : t.id || t.value;

        const found = taxes.find(tx => tx.id === taxId || tx.value === taxId);

        return {
          id: taxId,
          value: taxId,
          label: found?.label || found?.name || t.label || '',
          rate: found?.rate || t.rate || ''
        };
      });

      return {
        ...rest,
        [idKey]: customId || null,
        tax: enrichedTax
      };
    });
  };

  const isObjectEmpty = (obj) => {
    return Object.values(obj).every(
      (value) =>
        value === '' ||
        value === null ||
        value === undefined ||
        (typeof value === 'object' && value !== null && Object.values(value).every(v => v === '' || v === null || v === undefined))
    );
  };

  const filterNonEmptyObjects = (array) => {
    return array.filter((obj) => !isObjectEmpty(obj));
  };

  const handleSubmitItem = async (formData) => {
    setIsLoading(true)
    try {
      const { data, status } = await itemService.createItem(formData);
      if (status) {
        setItemCreated(prev => !prev);
        handleModalClose();
        // getAllItems()
        toast.success('Item Created Successfully.', {
          description: `${data.name} item Created Successfully.`,

        });
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const validationErrors = error.errors
        const formattedErrors = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
        );

        formikRef.current?.setErrors(formattedErrors);
        toast.error('Validation Error.', {
          description: 'Please check your input. Some fields may be invalid.',

        });
      }
    } finally {
      setIsLoading(false)
    }
  };

  const handleSubmitCategory = async (formData) => {
    try {
      setIsLoading(true);
      const { data, status } = await categoryService.createCategory(formData);
      if (status) {
        setCategoryCreated(prev => !prev);
        handleModalClose();
        toast.success(`Category Created`, {
          description: `${data.category_name} Category created successfully.`,

        })
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const validationErrors = error.errors
        const formattedErrors = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
        );

        formikRef.current?.setErrors(formattedErrors);
        toast.error('Validation Error.', {
          description: 'Please check your input. Some fields may be invalid.',

        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchemas[activeStep]}
        onSubmit={(values, { resetForm, setErrors }) => {
          if (isLastStep) {
            const removeKeys = (obj, keysToRemove) => {
              if (!obj || typeof obj !== 'object') return obj;
              const cleaned = { ...obj };
              keysToRemove.forEach((key) => delete cleaned[key]);
              return cleaned;
            };

            const cleanArrayObjects = (array, keysToRemove) =>
              Array.isArray(array) ? array.map((obj) => removeKeys(obj, keysToRemove)) : [];

            const {
              contact,
              matter,
              time_entries,
              flat_fees,
              expenses,
              ...rest
            } = values;

            // ✅ First: transform tax using available `taxes`
            const transformedTimeEntries = transformTaxFields(time_entries, 'item_id');
            const transformedFlatFees = transformTaxFields(flat_fees, 'item_id');
            const transformedExpenses = transformTaxFields(expenses, 'category_id');

            // ✅ Then: remove unused keys (like `taxes`, `item`, etc.)
            const nestedKeysToRemove = [
              'billed_by_user',
              'tax1',
              'tax2',
              'flat_fee',
              'expense',
              'template_Settings',
              'item',
              'taxes' // ← remove after enriching tax
            ];

            const payload = {
              ...rest,
              time_entries: filterNonEmptyObjects(cleanArrayObjects(transformedTimeEntries, nestedKeysToRemove)),
              flat_fees: filterNonEmptyObjects(cleanArrayObjects(transformedFlatFees, nestedKeysToRemove)),
              expenses: filterNonEmptyObjects(cleanArrayObjects(transformedExpenses, nestedKeysToRemove)),
            };

            console.log('>>>> payload', payload);
            return handleSubmit(payload, resetForm, setErrors);
          } else {
            setActiveStep((prev) => prev + 1);
          }
        }}
      >
        {({ values, errors, setFieldValue, isSubmitting, resetForm, setErrors }) => (
          console.log(errors),
          <Form>
            {/* Saving is only offered on the last step — the earlier steps submit
                to advance the wizard, not to create the invoice. */}
            <FormikUnsavedChangesGuard
              saving={createInvoice}
              canSave={isLastStep}
              saveLabel="Save invoice"
            />
            <div className='card'>
              <div className='card-header'>Create Invoice</div>
              <Stepper activeStep={activeStep} alternativeLabel className='mt-5 invoice-stepper'>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel className='!text-gray-600'>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div className='card-body px-2.5'>
                {/* {renderStepContent(activeStep)} */}
                <StepContainer activeStep={activeStep}>
                  <Setup
                    invoiceId={invoiceId}
                    templateData={templateData}
                    contactId={contactId}
                    matterId={matterId}
                    canFetchTemplateData={isEdit}
                  />
                  <Items
                    invoiceId={invoiceId}
                    templateData={templateData}
                    openModal={() => setOpenItem(true)}
                    loadOnChange={itemCreated}
                  />
                  <Expense
                    invoiceId={invoiceId}
                    templateData={templateData}
                    openModal={() => setOpen(true)}
                    loadOnChange={categoryCreated}
                  />
                  <FlatFees
                    invoiceId={invoiceId}
                    templateData={templateData}
                    openModal={() => setOpenItem(true)}
                    loadOnChange={itemCreated}
                  />
                  <CreateInvoice
                    invoiceId={invoiceId}
                    templateData={templateData}
                  />
                </StepContainer>
              </div>
              <div className='card-footer justify-end gap-2.5'>
                <button disabled={activeStep === 0 || createInvoice} type='button' className='btn btn-sm btn-light' onClick={() => setActiveStep(activeStep - 1)}>
                  <KeenIcon icon="black-left" />
                  Go Back
                </button>

                <button type="submit" disabled={createInvoice} className='btn btn-sm btn-primary' >
                  {createInvoice
                    ? 'Please Wait...'
                    : isLastStep
                      ? isEdit ? 'Update Invoice' : 'Create Invoice'
                      : activeStep === 0
                        ? 'Next Step'
                        : 'Skip & Next'
                  }
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ItemsModal
        open={openItem}
        onCloseModal={handleModalClose}
        handleMode={mode}
        data={selectedData}
        onSubmit={handleSubmitItem}
        createFieldLoading={isLoading}
        updateFieldLoading={loading}
        taxesData={taxesData}
        ref={formikRef}
        showTaxes={false}
        showDescription={false}
      />
      <CategoryModal
        open={open}
        onCloseModal={handleModalClose}
        handleMode={mode}
        data={selectedData}
        onSubmit={handleSubmitCategory}
        createFieldLoading={isLoading}
        updateFieldLoading={loading}
        ref={formikRef}
      />
    </>
  );
};

export { AddInvoice };